import { faCircleInfo, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cloneElement } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface InfoIconProps {
  id?: string;
  isWarning?: boolean;
  children: JSX.Element;
  style?: {[key:string]:string};
}

function InfoIcon(props:InfoIconProps) {
  const { children, id, isWarning, style } = props;
  const icon = <FontAwesomeIcon icon={isWarning ? faCircleExclamation : faCircleInfo} style={{ color: isWarning ? "red" : "#357ebd" }} fixedWidth></FontAwesomeIcon>;
  const uid = id ? id : (Math.random() * 100).toString();

  return (
    <OverlayTrigger
      key={uid}
      placement="auto"
      overlay={( props ) => {
        return (                        
          <Tooltip {...props} id={uid}>
            {(() => {
              return cloneElement(children, {});
            })()}
          </Tooltip>
        );
      }}>
      <span style={{...style}}>{icon}</span>
    </OverlayTrigger>
  );
}

export default InfoIcon;
